import React from 'react';
import './index.css';

import IconTrashCan from '../icons/IconTrashCan'

const BinName = ({row,part}) => {
  const text = [part ? row.primaryPartnum:row.binName ]
  return (
    <span className="bin-name-deletable">
      <span className="bin-name-deletable__bin-name">{text}</span>
    </span>
  );
}

export default BinName;
